import { render, staticRenderFns } from "./deviceShareDetail.vue?vue&type=template&id=24ca2404&scoped=true&"
import script from "./deviceShareDetail.vue?vue&type=script&lang=js&"
export * from "./deviceShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./deviceShareDetail.vue?vue&type=style&index=0&id=24ca2404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca2404",
  null
  
)

export default component.exports